import './answers.less';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cn from 'classname';
import AnswerForms from './answer-form';
import Avatar from '../../shared/avatar';
import avatars from '../../../config/avatars';

class Answers extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			itemsWidth: 0
		};
	}

	componentDidMount() {
		scrollToLast.call(this);
		setItemsWidthByWrap.call(this);
		window.addEventListener('resize', setItemsWidthByWrap.bind(this));
	}

	componentDidUpdate(prevProps, nextState) {
		if (this.props.data.posts.length != prevProps.data.posts.length) {
			scrollToLast.call(this);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', setItemsWidthByWrap.bind(this));
	}

	render() {
		const {
			data,
			intl,
			submitAnswer,
			submitEdit,
			preparationFile,
			attachmentsInfo,
			answerFormInitialValues,
			toggleEditMode,
			isEditMode,
			removeFile,
			can,

			cannedReply,
			substituteWithCannedReply,
			editCannedReply,
			openCannedReplyForm,
			deleteCannedReply
		} = this.props;

		return (
			<div className="thread-container">
				<div className="container__content-title">
					<div className="container__content-title-position" />
				</div>

				<div className="support__answers">
					<div ref="wrap" className="support__answers-items">
						{data.posts.map((post, index) => (
							<div
								className={cn({
									answer: true,
									affiliate: post.author === 'affiliate',
									admin: post.author === 'admin',
									clearfix: true,
									['is-close-msg']: post.isCloseMessage
								})}
								key={index}
							>
								<Avatar
									className="answer__avatar"
									src={
										post.avatar ||
											(post.author === 'admin'
												? avatars.adminSmall
												: avatars.affiliateSmall)
									}
								/>
								<div className="answer__item" style={{maxWidth: this.state.itemsWidth}}>
									<div className="answer__item-head clearfix">
										<p className="email">{post.name || intl('System')}</p>
										<p className="date">{moment(post.updated_at).format('DD.MM.YYYY HH:mm:ss')}</p>
										{post.author === 'admin' &&
											!post.viewed_at && (
											<div className="unread">
												{!post.is_notification_sent &&
														!data.closed_at && <span className="edit" onClick={() => toggleEditMode(post.id)} />}
												<span className="tick" />
											</div>
										)}
										{post.author === 'admin' &&
											!!post.viewed_at && (
											<span className="read">
												<span />
												<span />
											</span>
										)}
									</div>
									<p className="text">{post.text}</p>
									{post.attachments && (
										<div className="attachments">
											{post.attachments.map((attach, i) => (
												<a key={i} href={attach.path} alt={attach.name} target="_blank">
													{attach.name}
												</a>
											))}
										</div>
									)}
								</div>
							</div>
						))}
						<div className="support__answers_empty" ref="last" />
					</div>
					<CannedRepliesList
						cannedReplies={cannedReply.data}
						substituteWithCannedReply={substituteWithCannedReply}
						editCannedReply={editCannedReply}
						openCannedReplyForm={openCannedReplyForm}
						deleteCannedReply={deleteCannedReply}
						intl={intl}
					/>
					{can('answer') && (
						<AnswerForms
							ref="form"
							submitAnswer={submitAnswer}
							submitEdit={submitEdit}
							isClosed={data.status === 'closed'}
							isEditMode={isEditMode}
							preparationFile={preparationFile}
							removeFile={removeFile}
							attachmentsInfo={attachmentsInfo}
							initialValues={answerFormInitialValues}
							enableReinitialize={true}
							intl={intl}
						/>
					)}
				</div>
			</div>
		);
	}
}

function scrollToLast() {
	const $wrap = this.refs['wrap'];
	const $last = this.refs['last'];
	$wrap.scrollTop = $last.offsetTop;
}

function setItemsWidthByWrap() {
	const { width } = this.refs['wrap'].getBoundingClientRect();
	this.setState({
		itemsWidth: width - 100
	});
}

Answers.propTypes = {
	data: PropTypes.object,
	submitAnswer: PropTypes.func,
	submitEdit: PropTypes.func,
	toggleEditMode: PropTypes.func,
	isEditMode: PropTypes.bool,
	answerFormInitialValues: PropTypes.object,
	preparationFile: PropTypes.func,
	removeFile: PropTypes.func,
	attachmentsInfo: PropTypes.array,

	cannedReply: PropTypes.object,
	substituteWithCannedReply: PropTypes.func,
	submitCannedReply: PropTypes.func,
	editCannedReply: PropTypes.func,
	deleteCannedReply: PropTypes.func,
	openCannedReplyForm: PropTypes.func,

	can: PropTypes.func,
	intl: PropTypes.func
};

export default Answers;

const CannedRepliesList = ({
	cannedReplies,
	substituteWithCannedReply,
	openCannedReplyForm,
	editCannedReply,
	deleteCannedReply,
	intl
}) => (
	<div className="canned-replies-container">
		<div>
			{cannedReplies &&
				cannedReplies.map(reply => (
					<span
						key={reply.id}
						title={reply.text}
						className={cn({
							'canned-reply': true,
							'font-roboto-regular': true,
							active: false
						})}
						onClick={() => substituteWithCannedReply(reply.text)}
					>
						<span className="canned-reply__text">{reply.title}</span>
						<span
							className="canned-reply__edit-icon"
							onClick={e => {
								e && e.stopPropagation();
								editCannedReply(reply.id);
							}}
						/>
						<span
							className="canned-reply__delete-icon"
							onClick={e => {
								e && e.stopPropagation();
								deleteCannedReply(reply.id);
							}}
						/>
					</span>
				))}

			<span className="add-canned-reply" onClick={openCannedReplyForm}>
				{intl('Add')}
			</span>
		</div>
	</div>
);

CannedRepliesList.propTypes = {
	cannedReplies: PropTypes.array,
	substituteWithCannedReply: PropTypes.func,
	openCannedReplyForm: PropTypes.func,
	editCannedReply: PropTypes.func,
	deleteCannedReply: PropTypes.func,
	intl: PropTypes.func
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/answers.js